import React from "react";
import { connect } from "react-redux";
import {
    LiveKitRoom,
    RoomAudioRenderer,
    StartAudio,
} from "@livekit/components-react";
import { fetchToken } from "../../store/livekit";
import PropTypes from "prop-types";

const LIVEKIT_WS_URL = import.meta.env.VITE_APP_LIVEKIT_WS_URL;

class LiveKitService extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
        };

        this.liveKitRoom = React.createRef();
    }

    componentDidMount() {
        // const { courseInfo, courseTokenValues } = this.props;
        // if (courseInfo) {
        console.log("status getToken", this.props.status);
        // }
    }

    componentDidUpdate() {
        // const { courseInfo, status, courseTokenValues } = this.props;
        // if (courseInfo !== prevProps.courseInfo || status !== prevProps.status) {
        //     this.getTokenMemoized(courseInfo, courseTokenValues);
        // }
    }

    onDeviceFailure = () => {
        console.error("Device failure occurred");
    };

    render() {
        const { status, children } = this.props;
        console.log("status", status);

        return (
            <LiveKitRoom
                ref={this.liveKitRoom}
                token={this.props.tokenValues}
                serverUrl={LIVEKIT_WS_URL}
                connect={status}
                video={false}
                audio={true}
                onDeviceFailure={this.onDeviceFailure}
                onConnected={() => {
                    console.log("LiveKit Room connected");
                }}
                onDisconnected={() => {
                    console.log("LiveKit Room disconnected");
                    // this.getTokenMemoized();
                }}
                onError={(err) => {
                    console.error("Livekit Error", err);
                }}
                onPlayCapture={(e) => {
                    console.log("onPlayCapture", e);
                }}
            >
                {children}
                <RoomAudioRenderer volume={0} />
                <StartAudio label="Click to allow audio playback" />
            </LiveKitRoom>
        );
    }
}

// Connect to Redux store
const mapStateToProps = (state) => ({
    tokenValues: state.livekit.token,
    status: state.livekit.status,
});

const mapDispatchToProps = (dispatch) => ({
    getToken: (params) => dispatch(fetchToken(params)),
});

// Define prop types
LiveKitService.propTypes = {
    status: PropTypes.bool.isRequired, // Connection status for LiveKit
    loading: PropTypes.bool, // Loading state from Redux
    tokenValues: PropTypes.string, // Token for connecting to LiveKit, can be null
    children: PropTypes.node, // Child components to be rendered inside LiveKitRoom
    getToken: PropTypes.func.isRequired, // Dispatch function to fetch token
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveKitService);
